
import React from 'react';
import Portfolio from './Portfolio';
import Contact from './Contact';
import '../styles/Home.css';
import About from '../components/About';
import Experience from '../components/Experience';
import Header from '../components/Header';


function Home() {
  return (
        <div className='home-a'>
            <div className='home'>
                <div>
                    <Header />
                </div>
                 <div className='portfolio_about'>
                    <About />
                </div>
                
                <div className='portfolio_experience'>
                    <Experience />
                </div>
                
                <div className='portfolio_portfolio'>
                    <Portfolio />
                </div>

                 <div className='portfolio_contact'>
                    <Contact />
                </div>  
            </div>
        </div>
  )
}

export default Home;